import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { format, addMonths } from 'date-fns';
import { fr } from 'date-fns/locale';

const CustomCalendarHeader = ({ currentMonth, onMonthChange }) => {
  const raw = format(currentMonth, 'MMMM yyyy', { locale: fr });
  const label = raw.charAt(0).toUpperCase() + raw.slice(1);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: '8px', pt: '8px', pb: '4px' }}>
      <IconButton size="small" onClick={() => onMonthChange(addMonths(currentMonth, -1), 'right')} sx={{ color: '#000000' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </IconButton>
      <Typography sx={{ fontFamily: 'Montserrat', fontWeight: 700, fontSize: '20px', color: '#000000' }}>
        {label}
      </Typography>
      <IconButton size="small" onClick={() => onMonthChange(addMonths(currentMonth, 1), 'left')} sx={{ color: '#000000' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </IconButton>
    </Box>
  );
};

export default CustomCalendarHeader;
